// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c7787863","732":"2502686f","977":"dc8cd64c"}[chunkId] + ".chunk.js";
};